import { Division } from '@core/models';

import { CreateDivisionDto, DivisionDto } from './divisions.dto';

/**
 * Divisions, across the two vocabularies.
 *
 * Our `id` is their `code` and our `code` is their `referenceNumber` — the names
 * crossed over long before either side was written down, and this is the only
 * place that knows.
 *
 * `opco` and `type` used to sit on our model with no form and no column behind
 * them. Both are gone — confirmed with the backend on 8 October under "the form is
 * the test" (standards §8b).
 */
export function divisionFromDto(dto: DivisionDto): Division {
  return {
    id: dto.code,
    code: dto.referenceNumber ?? '',
    name: dto.name ?? '',
    process: dto.operatingSystemCode ?? '',
    description: dto.description ?? '',
  };
}

/** A division on the way out. The same body creates and replaces. */
export function divisionToDto(d: Division): CreateDivisionDto {
  return {
    code: d.id,
    referenceNumber: d.code,
    name: d.name,
    operatingSystemCode: d.process || null,
    description: d.description || null,
  };
}

/** True where anything the server stores differs — what decides a PUT. */
export function divisionChanged(a: Division, b: Division): boolean {
  return (
    a.code !== b.code ||
    a.name !== b.name ||
    a.process !== b.process ||
    a.description !== b.description
  );
}
